export const USER_INFO = "USER_INFO"
export const USER_SUCCESS = "USER_SUCCESS"
export const USER_ERROR = "USER_ERROR"
export const USER_LOGOUT = "USER_LOGOUT"
